import React from "react";
import {Row, Col, Form, Input, Select} from 'antd';


const { TextArea } = Input;
const {Option} = Select;

const TabOutrasInformacoes = ({dataTab})=> {

    
    return (
        <Row gutter={[16, 16]}>
           
           
            
            
            <Col sm={24}>
                <Form.Item label="Fabricante" name="fabricante">
                    <Input data-tab={dataTab} />
                </Form.Item>
            </Col>
        
            <Col sm={12}>
                <Form.Item label="Informações Adicionais Produto" name="infAdicProduto">
                    <TextArea data-tab={dataTab} rows={5} />
                </Form.Item>
            </Col>
            
            <Col sm={12}>
                <Form.Item label="Informações Adicionais Nota" name="infAdicNota">
                    <TextArea data-tab={dataTab} rows={5} />
                </Form.Item>
            </Col>

            <Col sm={12}>
                <Form.Item label="Tags" name="tag">
                    <TextArea data-tab={dataTab} rows={5} />
                </Form.Item>
            </Col>
        
            
            
        </Row>
    );
}

export {TabOutrasInformacoes};